import {option, Option} from "ts-option";
import {PaymentRecommendationApiDto} from "../../api/model/rest";
import moment = require("moment");

export default class PaymentRecommendation {

	constructor(public readonly id: string,
		public readonly amount: number,
		public readonly datePaid: moment.Moment,
		public readonly paymentMethod: string,
		public readonly paymentMethodDetails: Option<string>,
		public readonly reference: Option<string>) {
	}

	public static fromJson(json: PaymentRecommendationApiDto): PaymentRecommendation {
		return new PaymentRecommendation(json.id, json.amount, moment(json.datePaid), json.paymentMethod,
			option(json.paymentMethodDetails), option(json.reference))
	}
}